import moment from 'moment';
import { getMomentDateStringFromRangeArray } from '@/utils/dateUtil';
import { BILLING_SOURCE_API } from '@/api';

const state = {
  tableData: [],
};

const actions = {
  async fetchBillingMeterData({ commit }, parameters = {}) {
    const { startDate, endDate } = getMomentDateStringFromRangeArray(parameters.tradeDateRangeSelected);
    const params = {
      contracts: parameters.contractsSelected,
      startDate,
      endDate,
    };
    try {
      const { data: { data } } = await BILLING_SOURCE_API.post('/meter/count/get', params);
      if (Array.isArray(data)) {
        data.forEach((x) => {
          x.tradingDate = moment(x.tradingDate).utc().format('MM/DD/YYYY');
          if (parameters.isNegativeChannelOneSelected) {
            x.val = x.channel === 1 ? -x.val : x.val;
          }
        });
        commit('setTableData', data);
      }
    } catch (err) {
      console.error(err);
      this.$notify('Failed to load Meter Data', 'error');
    }
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = Object.freeze(value);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};